import { OptionsObject, useSnackbar } from 'notistack';
import { useCallback } from 'react';

export const useToasts = () => {
  const { enqueueSnackbar } = useSnackbar();

  const triggerToast = useCallback((message: string, options: OptionsObject) => {
    enqueueSnackbar(message, options);
  }, []);

  return { triggerToast };
};
